


















import { snakeCase } from 'lodash'
import Vue from "vue"
import Component from "vue-class-component"
import { Prop } from "vue-property-decorator"

import CustomEditor from '../../logic/Editor/CustomEditor'
import CustomInput from './CustomInput'
import CustomOutput from './CustomOutput'

@Component({
  name: 'Socket',
  data() {
    return {
      snakeCase,
    }
  }
})
export default class Socket extends Vue {
  @Prop() socket!: CustomInput | CustomOutput

  @Prop() editor!: CustomEditor

  mounted(): void {
    if (this.socket instanceof CustomOutput) {
      this.socket.setIsVisible(true)
    }
  }

  destroyed(): void {
    if (this.socket instanceof CustomOutput) {
      this.socket.setIsVisible(false)

      if (!this.socket.isMoved) {
        /**
         * При изменении состояния видимости (удалении непосредственно выхода, либо просто сокрытии, как в случае с выходом бездействия)
         * автоматически обрубит все соединения с этим соккетом
         * */
        this.socket.connections.forEach((c) => this.editor.removeConnection(c))
      }
    }
  }
}
